import React, { useEffect } from "react";
import AOS from "aos";
import 'aos/dist/aos.css';
const Aboutalumniassociaton = () =>{
       useEffect(() => {
                AOS.init();
                AOS.refresh();
            }, [])
    return (
<div>
<section className="about-main-section">
<div className="text-center about-tiilte-sec">
<p className="about-tiilte-sec-head">about Alumni Association</p>
<p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
about Alumni Association</p>
</div>
    </section>
    <section className="aboutdepartment-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-6 order-2 order-lg-1">
                                <div className="aboutdepartment-left-sec">
                               <p className="ab-depart-subheading" data-aos="fade-up" data-aos-delay="300" data-aos-duration="300">SVU Zoology Alumni Association</p>
                               <p className="home-about-head" data-aos="fade-up" data-aos-delay="300" data-aos-duration="600">about Alumni Association</p>
                               <p className="home-about-para" data-aos="fade-up" data-aos-delay="300" data-aos-duration="900">The SVU Zoology Department Alumni Association unites a diverse and accomplished network of graduates who have excelled in academia, research, and various industries worldwide. Our alumni have made significant contributions to life sciences, both in India and abroad, holding esteemed positions in research organizations, universities, and the corporate world. <br /> <br />

The Association is deeply committed to fostering connections among alumni, supporting the department’s growth, and promoting excellence in zoological research and education. By organizing annual alumni meets, collaborative initiatives, and knowledge-sharing events, we aim to preserve the department’s legacy and inspire future generations of zoologists. <br /> <br />

Together, as proud members of the SVU Zoology family, we honor our shared heritage and strive to advance the frontiers of zoological science.</p>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 order-2 order-lg-1">
                            {/* <img src={alumniassociationimg} className="alumniassociationimg" /> */}
                            <div className="alumniassociationimg"></div>
                            </div>
                        </div>
                    </div>
                </section>
</div>
    )
}
export  default  Aboutalumniassociaton ;